/** Client-only keys on Functional Table rows (see Functional/Table wrapper). */
const ROW_KEYS_ALWAYS_OMIT = new Set(["rawFields", "isnewData"]);

const isRelationObject = value =>
  value !== null &&
  typeof value === "object" &&
  !(value instanceof Date) &&
  !Array.isArray(value);

const RELATION_ROW_FIELDS = new Set(["invoice", "instance", "item", "type"]);

const isRelationShapedRowField = (key, value) =>
  RELATION_ROW_FIELDS.has(key) && isRelationObject(value);

const INVALID_NUMBER = Symbol("INVALID_NUMBER");

const normaliseCurrencyValue = (value, { allowEmpty } = {}) => {
  if (value === "") return allowEmpty ? null : 0;
  if (value == null) return value;

  const numericValue = typeof value === "number" ? value : Number(value);
  return Number.isFinite(numericValue) ? numericValue : INVALID_NUMBER;
};

const sanitiseTableRowUpdate = (changedFields, headers = []) => {
  const currencyHeadersByName = headers
    .filter(
      header =>
        typeof header === "object" &&
        header?.type === "input" &&
        header?.inputType === "number-currency",
    )
    .reduce(
      (headersByName, header) => ({
        ...headersByName,
        [header.name]: header,
      }),
      {},
    );

  return Object.fromEntries(
    Object.entries(changedFields || {})
      .filter(
        ([key, value]) =>
          value !== undefined &&
          !(typeof value === "number" && !Number.isFinite(value)) &&
          !ROW_KEYS_ALWAYS_OMIT.has(key) &&
          !isRelationShapedRowField(key, value),
      )
      .map(([key, value]) => {
        const header = currencyHeadersByName[key];
        const normalisedValue = header
          ? normaliseCurrencyValue(value, header)
          : value;
        const isInvalidInteger =
          header?.allowDecimal === false &&
          normalisedValue !== null &&
          !Number.isInteger(normalisedValue);

        return [
          key,
          isInvalidInteger ? INVALID_NUMBER : normalisedValue,
        ];
      })
      .filter(([, value]) => value !== INVALID_NUMBER),
  );
};

const ROW_UPDATE_DEBOUNCE_MS = 500;

export { ROW_UPDATE_DEBOUNCE_MS, sanitiseTableRowUpdate };
